<template>
  <div class="function-page">
    <div class="overlay"></div>
    <Header />
    
    <section class="nei-banner" :style="{ background: ' url(' + require('@/assets/images/banner.jpg') + ') center/cover no-repeat' }">
      <div class="container">
        <div class="banner-content"> 
          <h1>产品功能</h1>
          <h2>腾智ERP：全场景智能协同，驱动制造企业高效增长</h2>
          <p>腾智ERP深度融合AI、IoT与低代码技术，打造"计划-执行-分析"全链路闭环，助力制造业实现生产透明化、管理精细化、决策智能化，平均为客户提升30%运营效率！</p>
        </div>
      </div>
    </section>

    <main class="content-wrapper">
      <div class="container">
        <div class="feature-header">
          <h2 class="main-title">多种管理场景管简单全部搞定</h2>
          <div class="menu-tabs">
            <a href="#production" class="menu-tab">生产管理</a>
            <a href="#material" class="menu-tab">物料管理</a>
            <a href="#performance" class="menu-tab">绩效工资</a>
          </div>
        </div>

        <section class="feature-section" id="production">
          <div class="feature-content">
            <h3>管生产，订单执行可视化</h3>
            <ul class="feature-list">
              <li>实时报工，打破车间黑匣子</li>
              <li>生产过程标准化，在线作业标准指导书，规范操作</li>
              <li>通过工单增加客户信息、筛选方案，个性化服务不同客户</li>
            </ul>
            <a href="https://sdtz.guanjd.com/#/" class="try-button">申请体验</a>
          </div>
          <div class="feature-image">
            <img src="@/assets/images/case-0.gif" alt="生产管理功能展示">
          </div>
        </section>

        <section class="feature-section" id="material">
          <div class="feature-image">
            <img src="@/assets/images/case-1.gif" alt="物料管理功能展示">
          </div>
          <div class="feature-content">
            <h3>管物料，料动账随</h3>
            <ul class="feature-list">
              <li>与生产联动，通过报工自动出入库并实时更新，自动生成出库单</li>
              <li>数据系统云端存储不易丢失，通过权限设置实现定向共享，多端查看</li>
            </ul>
            <a href="https://sdtz.guanjd.com/#/" class="try-button">申请体验</a>
          </div>
        </section>

        <section class="feature-section" id="performance">
          <div class="feature-content">
            <h3>管工资绩效，实时核算</h3>
            <ul class="feature-list">
              <li>计时/计件薪资灵活配置，公式自动计算薪酬，员工随时查看报工和工资汇总数据，工价变更可即时刷新</li>
              <li>工资报表、绩效报表一键导出，解放财务劳动力</li>
            </ul>
            <a href="https://sdtz.guanjd.com/#/" class="try-button">申请体验</a>
          </div>
          <div class="feature-image">
            <img src="@/assets/images/case-2.gif" alt="绩效工资功能展示">
          </div>
        </section>
      </div>

      <section class="detail-section">
        <div class="container">
          <h2 class="section-title">小工单的能力，体现在每个细节</h2>
          
          <div class="detail-tabs">
            <div v-for="(detail, index) in details" 
                 :key="index" 
                 class="detail-tab" 
                 :class="{ active: activeDetailTab === index }" 
                 @click="activeDetailTab = index" 
                 :data-tab="detail.id">
              {{ detail.name }}
            </div>
          </div>

          <div class="detail-content">
            <div v-for="(detail, index) in details" 
                 :key="index" 
                 class="detail-item" 
                 :class="{ active: activeDetailTab === index }" 
                 :data-content="detail.id">
              <div class="detail-text">
                <h3>{{ detail.title }}</h3>
                <p v-for="(line, lIndex) in detail.description" :key="lIndex">{{ line }}</p>
                <a href="https://sdtz.guanjd.com/#/" class="detail-btn">申请体验</a>
              </div>
              <div class="detail-image">
                <img :src="require(`@/assets/images/${detail.image}`)" :alt="detail.title">
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="feature-overview">
        <div class="feature-container">
          <h2 class="section-title">管简单一体化全功能一览</h2>
          <div class="modules">
            <div v-for="(module, index) in modules" :key="index" class="module">
              <div class="module-title">{{ module.title }}</div>
              <div class="module-content">
                <ul>
                  <li v-for="(item, iIndex) in module.items" :key="iIndex">{{ item }}</li>
                </ul>
                <p style="color: orange; margin: 5px 0 0;">功能自定义</p>
              </div>
            </div>
          </div>

          <div class="features">
            <div class="feature-group">
              <div class="feature-group-title">互动协作</div>
              <div class="feature-mid">
                <span class="feature">电话</span>
                <span class="feature">短信</span>
                <span class="feature">邮件</span>
                <span class="feature">微信</span>
                <span class="feature">QQ</span>
                <span class="feature">传真</span>
                <span class="feature">互联网</span>
                <span class="feature">WAP</span>
                <span class="feature">......</span>
              </div>
              <div class="feature-right">
                <i></i><span>社交化</span>
              </div>
            </div>

            <div class="feature-group">
              <div class="feature-group-title">管理工具</div>
              <div class="feature-mid">
                <span class="feature">二维码</span>
                <span class="feature">条形码</span>
                <span class="feature">扫描枪</span>
                <span class="feature">序列号</span>
                <span class="feature">保质期</span>
                <span class="feature">生产批号</span>
                <span class="feature">......</span>
              </div>
              <div class="feature-right">
                <i></i><span>多样化</span>
              </div>
            </div>

            <div class="feature-group">
              <div class="feature-group-title">增值功能</div>
              <div class="feature-mid">
                <span class="feature">可记忆表头</span>
                <span class="feature">DIY列表</span>
                <span class="feature">暂存式录入</span>
                <span class="feature">交互式图表</span>
                <span class="feature">可控式关联</span>
                <span class="feature">全自动对接</span>
                <span class="feature">......</span>
              </div>
              <div class="feature-right">
                <i></i><span>智能化</span>
              </div>
            </div>

            <div class="feature-group">
              <div class="feature-group-title">数据分析</div>
              <div class="feature-mid">
                <span class="feature">市场分析</span>
                <span class="feature">销售分析</span>
                <span class="feature">库存分析</span>
                <span class="feature">人资分析</span>
                <span class="feature">财务分析</span>
                <span class="feature">预警提醒</span>
                <span class="feature">......</span>
              </div>
              <div class="feature-right">
                <i></i><span>实时化</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="scene-section">
        <div class="container">
          <h2 class="scene-title">多个环境下，随时随地管理车间现场</h2>
          <div class="scene-grid">
            <div class="scene-card" data-color="blue">
              <div class="scene-image">
                <img src="@/assets/images/guanlicheng.jpg" alt="管理层应用场景">
              </div>
              <div class="scene-content">
                <h3>管理层</h3>
                <p>随时随地用手机监控关键指标</p>
              </div>
            </div>

            <div class="scene-card" data-color="green">
              <div class="scene-image">
                <img src="@/assets/images/yewuzhuguan.jpg" alt="业务主管应用场景">
              </div>
              <div class="scene-content">
                <h3>业务主管</h3>
                <p>周期性的数据统计、分析、优化</p>
              </div>
            </div>

            <div class="scene-card" data-color="purple">
              <div class="scene-image">
                <img src="@/assets/images/chejianxianchang.jpg" alt="车间现场应用场景">
              </div>
              <div class="scene-content">
                <h3>车间现场</h3>
                <p>查看关键数据，快速优化作业瓶颈</p>
              </div>
            </div>

            <div class="scene-card" data-color="orange">
              <div class="scene-image">
                <img src="@/assets/images/yzsyyjsc.jpg" alt="一站式运营驾驶舱">
              </div>
              <div class="scene-content">
                <h3>一站式运营驾驶舱</h3>
                <p>随时随地监控生产进度</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="testimonials-section">
        <div class="container">
          <h2 class="testimonials-title">客户证言</h2>
          
          <div class="industry-tabs">
            <button class="industry-tab active" @click="setActiveIndustry('machining')" :class="{ active: activeIndustry === 'machining' }">机加工行业</button>
            <button class="industry-tab" @click="setActiveIndustry('mold')" :class="{ active: activeIndustry === 'mold' }">模具行业</button>
            <button class="industry-tab" @click="setActiveIndustry('printing')" :class="{ active: activeIndustry === 'printing' }">印刷行业</button>
            <button class="industry-tab" @click="setActiveIndustry('fastener')" :class="{ active: activeIndustry === 'fastener' }">紧固件行业</button>
            <button class="industry-tab" @click="setActiveIndustry('auto')" :class="{ active: activeIndustry === 'auto' }">汽配行业</button>
            <button class="industry-tab" @click="setActiveIndustry('pneumatic')" :class="{ active: activeIndustry === 'pneumatic' }">气动行业</button>
          </div>

          <div class="testimonials-container">
            <div v-for="(group, industry) in testimonialsData" :key="industry" 
                 class="testimonials-group" 
                 :class="{ active: activeIndustry === industry }"
                 v-show="activeIndustry === industry">
              <div v-for="(testimonial, index) in group" :key="index" 
                   class="testimonial-card" 
                   :data-gradient="testimonial.gradient">
                <div class="testimonial-header">
                  <img :src="require(`@/assets/images/${testimonial.image}`)" :alt="testimonial.title" class="client-avatar">
                  <h3>{{ testimonial.title }}</h3>
                </div>
                <div class="testimonial-content">
                  <span class="quote-mark">"</span>
                  {{ testimonial.content }}
                  <span class="quote-mark">"</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
    </main>
    
    <Footer />
    <SideService />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import SideService from '@/components/SideService.vue';

export default {
  name: 'Function',
  components: {
    Header,
    Footer,
    SideService
  },
  data() {
    return {
      activeDetailTab: 0,
      activeIndustry: 'machining',
      details: [
        {
          id: 'print',
          name: '打印模板',
          title: '打印模板',
          description: [
            '自定义打印模板，录入工单自动',
            '下载流转单和二维码，',
            '扫码报工，及时、准确，永久可追溯。'
          ],
          image: 'dymb.jpg'
        },
        {
          id: 'message',
          name: '消息提醒',
          title: '消息提醒',
          description: [
            '强大的消息提醒功能，可自定义条件',
            '触发各种逾期、临期、任务、异常、',
            '审批、安全库存等提醒，快捷高效。'
          ],
          image: 'xxtx.jpg'
        },
        {
          id: 'custom',
          name: '自定义配置',
          title: '自定义配置',
          description: [
            '字段、流程、报表、界面、权限等灵活丰富，',
            '的自定义配置功能，更好地适应企业的',
            '生产环境和工作流程'
          ],
          image: 'zdypz.jpg'
        },
        {
          id: 'report',
          name: '报表',
          title: '数据报表',
          description: [
            '自动生成统计产量、绩效、工资、不良品、',
            '生产等关键经营数据报表，可一键导出支持',
            '自定义配置报表，多维度个性化筛选方案，',
            '自动生成图表'
          ],
          image: 'sjbb.jpg'
        }
      ],
      modules: [
        {
          title: '销售管理',
          items: ['商机管理', '销售计划', '客户管理', '销售自动化', '洽谈进展', '报价管理', '合同管理', '销售退货', '售后管理', '产品管理', '设计中心', '对手分析']
        },
        {
          title: '呼叫中心',
          items: ['来电弹屏', '在线呼出', '通话录音', '通话记录', '联系人关联', '商机追踪', '黑名单', '来电存档', '来电列表', '来电查询', '客户电话加密', '统计分析']
        },
        {
          title: '库存管理',
          items: ['供应商管理', '预购管理', '采购管理', '到货提醒', '采购退货', '库存查看', '入库出库', '调拨盘点', '借货还货', '库存预警', '物流对接', '发货管理']
        },
        {
          title: '生产管理',
          items: ['物料管理', '物料清单', '工艺中心', '工序管理', '生产看板', '生产派工', '车间管理', '委外加工', '进度跟踪', '设备管理', '分析中心', '计件工资']
        },
        {
          title: '财务管理',
          items: ['多币种', '承兑汇票', '现金银行', '收款付款', '销售退款', '采购退款', '成本管理', '销售对账', '费用管理', '发票管理', '财务账表', '统计分析']
        },
        {
          title: '办公管理',
          items: ['常用工具', '通讯录', '知识库', '备忘录', '公司公告', '工作互动', '日程管理', '文档管理', '日程点评', '周月年报', '生日提醒', '移动办公']
        },
        {
          title: '账号管理',
          items: ['组织构架', '权限模板', '权限复制', '权限分配', '登录控制', '人名签章', '绑定移动', '员工检索', '账号冻结激活', '账号数据转移', '在线用户查看', '操作日志查询']
        }
      ],
      testimonialsData: {
        machining: [
          {
            title: '机加工行业总监',
            content: '系统帮助我们提升了30%的生产效率，实现了精细化管理',
            image: 'a1.jpg',
            gradient: 'blue'
          },
          {
            title: '生产主管',
            content: '数据可视化功能让生产监控变得如此简单',
            image: 'a2.jpg',
            gradient: 'green'
          },
          {
            title: '车间主任',
            content: '工单管理系统极大提高了我们的工作效率',
            image: 'a3.jpg',
            gradient: 'purple'
          },
          {
            title: '采购经理',
            content: '库存预警和采购建议功能帮助我们优化了采购流程',
            image: 'a4.jpg',
            gradient: 'orange'
          }
        ],
        mold: [
          {
            title: '模具厂厂长',
            content: '库存管理功能帮助我们降低了库存成本',
            image: 'b1.jpg',
            gradient: 'orange'
          },
          {
            title: '技术总监',
            content: '生产计划排程更加合理，交付周期缩短了20%',
            image: 'b2.jpg',
            gradient: 'green'
          },
          {
            title: '生产经理',
            content: '质量追溯系统帮助我们提升了产品合格率',
            image: 'b3.jpg',
            gradient: 'blue'
          },
          {
            title: '设备主管',
            content: '设备维护提醒功能让我们的设备管理更加规范',
            image: 'b4.jpg',
            gradient: 'purple'
          }
        ],
        printing: [
          {
            title: '印刷厂负责人',
            content: '智能排产系统大大提升了我们的生产效率',
            image: 'c1.jpg',
            gradient: 'purple'
          },
          {
            title: '运营总监',
            content: '成本核算更加精准，利润分析一目了然',
            image: 'c2.jpg',
            gradient: 'orange'
          },
          {
            title: '生产主管',
            content: '物料管理系统帮助我们降低了库存积压',
            image: 'c3.jpg',
            gradient: 'blue'
          },
          {
            title: '客户经理',
            content: '订单跟踪系统让客户服务更加专业高效',
            image: 'c4.jpg',
            gradient: 'green'
          }
        ],
        fastener: [
          {
            title: '企业负责人',
            content: '生产数据实时监控，管理决策更加准确',
            image: 'd1.jpg',
            gradient: 'green'
          },
          {
            title: '品质经理',
            content: '质量管理体系更加完善，客户满意度提升',
            image: 'd2.jpg',
            gradient: 'purple'
          },
          {
            title: '生产经理',
            content: '设备管理更加科学，维护成本明显降低',
            image: 'd3.jpg',
            gradient: 'orange'
          },
          {
            title: '工艺工程师',
            content: '工艺参数管理让产品质量更加稳定',
            image: 'd4.jpg',
            gradient: 'blue'
          }
        ],
        auto: [
          {
            title: '汽配企业总经理',
            content: '系统帮助我们建立了完整的追溯体系',
            image: 'e1.jpg',
            gradient: 'blue'
          },
          {
            title: '技术主管',
            content: '产品质量管控更加严格，废品率大幅降低',
            image: 'e2.jpg',
            gradient: 'green'
          },
          {
            title: '生产总监',
            content: '生产效率提升显著，员工管理更加规范',
            image: 'e3.jpg',
            gradient: 'purple'
          },
          {
            title: '供应链总监',
            content: '供应商协同功能让采购管理更加高效',
            image: 'e4.jpg',
            gradient: 'orange'
          }
        ],
        pneumatic: [
          {
            title: '气动设备厂长',
            content: '生产计划执行更加灵活，产能利用率提升',
            image: 'f1.jpg',
            gradient: 'orange'
          },
          {
            title: '运营经理',
            content: '数据分析功能强大，决策更加科学',
            image: 'f2.jpg',
            gradient: 'blue'
          },
          {
            title: '质量主管',
            content: '品质追溯更加便捷，客户投诉大幅减少',
            image: 'f3.jpg',
            gradient: 'green'
          },
          {
            title: '研发主管',
            content: '产品研发流程更加规范，创新效率提升',
            image: 'f4.jpg',
            gradient: 'purple'
          }
        ]
      }
    }
  },
  mounted() {
    // 添加滚动动画效果
    this.initScrollAnimations();
    
    // 详情标签切换逻辑
    this.initDetailTabs();
  },
  methods: {
    setActiveIndustry(industry) {
      this.activeIndustry = industry;
    },
    
    initScrollAnimations() {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      }, observerOptions);

      // 观察需要动画的元素
      this.$nextTick(() => {
        const elementsToAnimate = document.querySelectorAll(
          '.feature-section, .module, .detail-item, .scene-card, .testimonial-card, .feature-group'
        );
        elementsToAnimate.forEach(el => {
          observer.observe(el);
        });
      });
    },
    
    initDetailTabs() {
      // 详情标签切换已经通过 activeDetailTab 数据绑定实现
    }
  }
}
</script>

<style scoped>
:root {
  --primary-color: #009b7b;
}

/* Banner样式 */
.nei-banner {
  position: relative;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  margin-bottom: 3rem;
}

.banner-content {
  max-width: 900px;
  margin: 0 auto;
}

.banner-content h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.banner-content h2 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
}

.banner-content p {
  font-size: 1.1rem;
  line-height: 1.6;
}

/* 特征区域样式 */
.content-wrapper {
  padding: 2rem 0;
}

.feature-header {
  text-align: center;
  margin-bottom: 3rem;
}

.main-title {
  font-size: 2.5rem;
  margin-bottom: 2rem;
}

.menu-tabs {
  display: flex;
  justify-content: center;
  gap: 2rem;
}

.menu-tab {
  padding: 0.8rem 2rem;
  background: #f0f0f0;
  border-radius: 25px;
  text-decoration: none;
  color: #333;
  transition: all 0.3s;
}

.menu-tab:hover {
  background: #007bff;
  color: white;
}

.feature-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
  margin-bottom: 4rem;
  padding: 2rem 0;
}

.feature-content h3 {
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: #333;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
}

.feature-list li {
  padding: 0.8rem 0;
  padding-left: 1.5rem;
  position: relative;
  font-size: 1.1rem;
  line-height: 1.6;
}

.feature-list li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #007bff;
  font-weight: bold;
}

.try-button {
  display: inline-block;
  padding: 0.8rem 2rem;
  background: linear-gradient(135deg, var(--primary-color), #007a61);
  color: white;
  border-radius: 25px;
  text-decoration: none;
  transition: all 0.3s;
}

.try-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 155, 123, 0.3);
}

.feature-image img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

/* 详细信息区域 */
.detail-section {
  background: #f8f9fa;
  padding: 4rem 0;
  margin-top: 3rem;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
}

.detail-tabs {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 3rem;
}

.detail-tab {
  padding: 1rem 2rem;
  background: white;
  border: 2px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.detail-tab.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.detail-content {
  position: relative;
}

.detail-item {
  display: none;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
}

.detail-item.active {
  display: grid;
}

.detail-text h3 {
  font-size: 2rem;
  margin-bottom: 1.5rem;
}

.detail-text p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 0.5rem;
}

.detail-btn {
  display: inline-block;
  margin-top: 2rem;
  padding: 0.8rem 2rem;
  background: var(--primary-color);
  color: white;
  border-radius: 25px;
  text-decoration: none;
  transition: all 0.3s;
}

.detail-btn:hover {
  background: #007a61;
}

.detail-image img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* 初始状态 - 隐藏元素 */
.feature-section,
.module,
.detail-item,
.scene-card,
.testimonial-card,
.feature-group {
  opacity: 0;
}

/* 动画激活状态 */
.feature-section.animate-in {
  animation: fadeInUp 0.8s ease forwards;
}

.module.animate-in {
  animation: fadeInUp 0.6s ease forwards;
}

.detail-item.animate-in {
  animation: fadeInUp 0.8s ease forwards;
}

.scene-card.animate-in {
  animation: fadeInUp 0.6s ease forwards;
}

.testimonial-card.animate-in {
  animation: fadeInUp 0.5s ease forwards;
}

.feature-group.animate-in {
  animation: fadeInLeft 0.7s ease forwards;
}

/* 为不同元素添加延迟 */
.module:nth-child(1).animate-in { animation-delay: 0.1s; }
.module:nth-child(2).animate-in { animation-delay: 0.2s; }
.module:nth-child(3).animate-in { animation-delay: 0.3s; }
.module:nth-child(4).animate-in { animation-delay: 0.4s; }
.module:nth-child(5).animate-in { animation-delay: 0.5s; }
.module:nth-child(6).animate-in { animation-delay: 0.6s; }
.module:nth-child(7).animate-in { animation-delay: 0.7s; }

.scene-card:nth-child(1).animate-in { animation-delay: 0.1s; }
.scene-card:nth-child(2).animate-in { animation-delay: 0.2s; }
.scene-card:nth-child(3).animate-in { animation-delay: 0.3s; }
.scene-card:nth-child(4).animate-in { animation-delay: 0.4s; }

.testimonial-card:nth-child(1).animate-in { animation-delay: 0.1s; }
.testimonial-card:nth-child(2).animate-in { animation-delay: 0.15s; }
.testimonial-card:nth-child(3).animate-in { animation-delay: 0.2s; }
.testimonial-card:nth-child(4).animate-in { animation-delay: 0.25s; }

.feature-group:nth-child(1).animate-in { animation-delay: 0.1s; }
.feature-group:nth-child(2).animate-in { animation-delay: 0.2s; }
.feature-group:nth-child(3).animate-in { animation-delay: 0.3s; }
.feature-group:nth-child(4).animate-in { animation-delay: 0.4s; }

/* 功能概览 */
.feature-overview {
  padding: 4rem 0;
}

.feature-container {
  max-width: 1450px;
  margin: 0 auto;
  padding: 0 15px;
}

.features {
  margin-top: 3rem;
}

.feature-group {
  display: flex;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 1rem;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.feature-group-title {
  background: var(--primary-color);
  color: white;
  padding: 1.5rem;
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.feature-mid {
  flex: 1;
  padding: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.feature {
  background: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.feature-right {
  background: #f0f0f0;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: var(--primary-color);
}

.feature-right i {
  margin-right: 0.5rem;
}

.modules {
  display: flex;
  gap: 1rem;
  margin-top: 3rem;
  overflow-x: auto;
  padding-bottom: 1rem;
  scroll-snap-type: x mandatory;
}

.modules::-webkit-scrollbar {
  height: 8px;
}

.modules::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.modules::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 4px;
}

.modules::-webkit-scrollbar-thumb:hover {
  background: #007a61;
}

.module {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s;
  flex: 0 0 auto;
  width: calc((100% - 6rem) / 7);
  min-width: 180px;
  max-width: 195px;
  scroll-snap-align: start;
}

.module:hover {
  box-shadow: 0 8px 20px rgba(0, 155, 123, 0.15);
  transform: translateY(-8px);
}

.module-title {
  background: linear-gradient(135deg, var(--primary-color), #007a61);
  color: white;
  padding: 1.2rem;
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
}

.module-content {
  padding: 0;
}

.module-content ul {
  list-style: none;
  padding: 1rem 1.5rem 0.5rem;
  margin: 0;
}

.module-content li {
  padding: 0.4rem 0;
  border-bottom: 1px solid #f5f5f5;
  font-size: 0.8rem;
  color: #555;
  transition: all 0.2s;
  cursor: default;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.module-content li:hover {
  color: var(--primary-color);
  padding-left: 5px;
}

.module-content li:last-child {
  border-bottom: 1px solid #f5f5f5;
}

.module-content p {
  padding: 0.8rem 1.5rem 1rem;
  margin: 0;
}

/* 场景管理区域 */
.scene-section {
  background: #f8f9fa;
  padding: 4rem 0;
}

.scene-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
}

.scene-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}

.scene-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.scene-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.scene-image {
  overflow: hidden;
}

.scene-image img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: all 0.5s;
}

.scene-card:hover .scene-image img {
  transform: scale(1.1);
}

.scene-content {
  padding: 1.5rem;
  text-align: center;
}

.scene-content h3 {
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
  color: var(--primary-color);
}

.scene-content p {
  font-size: 0.95rem;
  color: #666;
}

.scene-card[data-color="blue"] h3 {
  color: #1e88e5;
}

.scene-card[data-color="green"] h3 {
  color: #43a047;
}

.scene-card[data-color="purple"] h3 {
  color: #8e24aa;
}

.scene-card[data-color="orange"] h3 {
  color: #f57c00;
}

/* 客户证言区域 */
.testimonials-section {
  padding: 4rem 0;
  background: #fff;
}

.testimonials-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
}

.industry-tabs {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;
}

.industry-tab {
  padding: 0.8rem 1.5rem;
  background: #f0f0f0;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 1rem;
}

.industry-tab.active {
  background: var(--primary-color);
  color: white;
}

.testimonials-container {
  position: relative;
}

.testimonials-group {
  display: none;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
}

.testimonials-group.active {
  display: grid;
}

.testimonial-card {
  background: white;
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
}

.testimonial-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.testimonial-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.client-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 1rem;
  object-fit: cover;
}

.testimonial-header h3 {
  font-size: 1rem;
  margin: 0;
}

.testimonial-content {
  flex: 1;
  font-style: italic;
  color: #666;
  font-size: 0.95rem;
  line-height: 1.6;
  position: relative;
}

.quote-mark {
  font-size: 1.5rem;
  font-weight: bold;
  color: rgba(0, 155, 123, 0.2);
  line-height: 0;
}

.testimonial-card[data-gradient="blue"] {
  border-top: 4px solid #1e88e5;
}

.testimonial-card[data-gradient="green"] {
  border-top: 4px solid #43a047;
}

.testimonial-card[data-gradient="purple"] {
  border-top: 4px solid #8e24aa;
}

.testimonial-card[data-gradient="orange"] {
  border-top: 4px solid #f57c00;
}


@media (max-width: 1400px) {
  .module {
    width: calc((100% - 5rem) / 6);
  }
}

@media (max-width: 1200px) {
  .module {
    width: calc((100% - 4rem) / 5);
  }
}

@media (max-width: 992px) {
  .feature-section,
  .detail-item {
    grid-template-columns: 1fr;
  }

  .module {
    width: calc((100% - 3rem) / 4);
    min-width: 220px;
  }

  .banner-content h1 {
    font-size: 2rem;
  }

  .banner-content h2 {
    font-size: 1.3rem;
  }
  
  .feature-group {
    flex-direction: column;
  }
  
  .feature-group-title {
    width: 100%;
    padding: 1rem;
  }
  
  .testimonials-group {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .scene-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .module {
    width: calc((100% - 2rem) / 3);
    min-width: 180px;
  }

  .menu-tabs {
    flex-direction: column;
    gap: 1rem;
  }

  .detail-tabs {
    flex-wrap: wrap;
  }

  .testimonials-group {
    grid-template-columns: 1fr;
  }
  
  .scene-grid {
    grid-template-columns: 1fr;
  }
}
</style>